import "./index.less";
import template from "./index.html";
import { EVENT_NEW_FORM } from "constants.js";

export function controller(appState, cardSwipeService, navigationService, eventBus, $scope) {
	const ctrl = this;

	ctrl.initCardSwipe = () => cardSwipeService.initializeCardSwipe();
	ctrl.$onInit = () => {
		updateNavigation();
		eventBus.register(EVENT_NEW_FORM, updateNavigation, $scope);
	};
	ctrl.$onChanges = updateNavigation;

	function updateNavigation() {
		ctrl.form = appState.forms.selected;
		ctrl.navigation = navigationService.getNavigation();
		ctrl.groups = [
			{ id: "primary", items: ctrl.navigation.primary },
			{ id: "administration", title: ctrl.navigation.administrationTitle, items: ctrl.navigation.administration }
		].filter(group => group.items.length > 0);
	}
}

export default angular
	.module("vesl.screens.dashboard", [])
	.component("dashboard", { template, controller }).name;
